<template>
<div class="col col-12 text-center">
    <div class="row justify-content-center ">
        <div class="col col-11 thankyou_box">
            <p>Kupón na pivo zdarma máte na svém emailu.</p>
            <p>Těšíme se na Vás!</p>
            <p><img src="@/assets/img/thanks.png" /></p>
            <a href="/pass.pkpass" class="btn btn-primary">Stáhnout do mobilu</a>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            selected: null,
            email: null
        }
    },
    name: 'thankyou',
    mountedd() {
        axios({
            url: '/pass.pkpass',
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'pass.pkpass'); //or any other extension
            document.body.appendChild(link);
            link.click();
        });
    }
}
</script>

<style scoped lang="scss">
@import 'src/scss/custom';

.thankyou_box {
    font-size: 22px;
    font-weight: bold;
    margin-top: 50px;
}
</style>
